import HttpService from './commons/HttpService';

import moment from 'moment';

const CustomerService = {
  sync(dataList, installationId) {
    return HttpService.post('/customers/sync', dataList, { params: { installationId } });
  },

  save(customer) {
    if (customer.id && customer.id > 0) {
      return this.update(customer);
    }
    return this.create(customer);
  },

  create(customer) {
    return HttpService.post('/customers', customer);
  },

  createAll(customers) {
    return HttpService.post('/customers/all', customers);
  },

  update(customer) {
    return HttpService.put(`/customers/${customer.id}`, customer);
  },

  updateComments(customerId, comments) {
    return HttpService.put(`/customers/${customerId}/comments`, { comments });
  },

  delete(customer) {
    return HttpService.delete(`/customers/${customer.id}`);
  },

  getById(id) {
    return HttpService.get(`/customers/${id}`);
  },

  findAllForCurrentUser() {
    return HttpService.get('/customers');
  },

  appointmentHistoryForCustomerId(customerId, startDate, endDate) {
    return HttpService.get(`/customers/${customerId}/appointments`, {
      params: { startDate, endDate },
    });
  },

  findBirthDayList(month) {
    return HttpService.get('/customers/birthDays', { params: { month } });
  },

  search(query) {
    return HttpService.get('/customers/search', { params: { query } });
  },

  searchExceptForId(query, exceptForIds) {
    return HttpService.get('/customers/searchExceptForId', {
      params: { query, exceptForIds: exceptForIds.join(',') },
    });
  },

  existsByPhone(phone1, exceptForId) {
    return HttpService.get('/customers/exists', { params: { phone1, exceptForId } });
  },

  getBasicStats(customerId) {
    return HttpService.get('/customers/basicStats', { params: { customerId } });
  },

  getCustomersGoneList(lastAppointmentDaysAgo, minNumberOfAppointments) {
    return HttpService.get('/customers/goneList', {
      params: { lastAppointmentDaysAgo, minNumberOfAppointments },
    });
  },

  getCustomersReturningList(numberOfDaysForReturning, serviceId, showAll) {
    return HttpService.get('/customers/returningList', {
      params: { numberOfDaysForReturning, serviceId, showAll },
    });
  },

  getCustomersByAppointmentStatus(appointmentStatus) {
    return HttpService.get('/customers/byAppointmentStatus', {
      params: { appointmentStatus },
    });
  },

  findAllForCurrentUserSliced(pageNumber, pageSize, searchTerm) {
    return HttpService.get('/customers/sliced', { params: { pageNumber, pageSize, searchTerm } });
  },

  findAllForCurrentUserPaged(pageNumber, pageSize, searchTerm) {
    return HttpService.get('/customers/paged', { params: { pageNumber, pageSize, searchTerm } });
  },

  findSimilarCustomers(customerId) {
    return HttpService.get('/customers/similarCustomers', { params: { customerId } });
  },

  joinCustomers(destinationCustomerId, customerIdsToUnify) {
    return HttpService.post('/customers/joinCustomers', { destinationCustomerId, customerIdsToUnify });
  },

  getProfileStats(customerId) {
    return HttpService.get('/customers/profileStats', { params: { customerId } });
  },

  exportForUser() {
    return HttpService.get(
      '/customers/exportAllForCurrentUser',

      {
        responseType: 'arraybuffer',
        // headers: {
        //   Accept: 'application/pdf',
        // },
      },
    ).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Clientes-' + moment().format('DD-MM-YY HH:mm') + '.xlsx');
      document.body.appendChild(link);
      link.click();
    });
  },

  getBirthdayCountForPeriod(startDate, endDate) {
    return HttpService.get('/customers/birthdayCount', {
      params: { startDate, endDate },
    });
  },

  getBirthdayListForPeriod(startDate, endDate) {
    return HttpService.get('/customers/birthdayList', {
      params: { startDate, endDate },
    });
  },

  findAutomaticCustomersToUnify(unifyType) {
    return HttpService.get('/customers/automaticCustomersToUnify', {
      params: { unifyType },
    });
  },

  unifyCustomers(customerIdsList, preferNameForFirstInTheList) {
    return HttpService.post('/customers/customersToUnify', {
      customerIdsList,
      preferNameForFirstInTheList,
    });
  },
};

export default CustomerService;
